<div class="card border-0 bg-transparent d-none d-xl-block" v-if="token_exists">
  <h6 class="card-header bg-transparent text-muted">Your events</h6>
  <div v-if="user_events.length === 0" class="text-center">
    <p class="text-muted text-xs fst-italic">You don't have any events</p>
  </div>
  <div class="rsvp-card" v-for="user_event in filteredEvents">
    <div class="d-flex align-items-center">
      <div class="date-box shadow-sm me-3">
        <small>{{ formatMonth(user_event.event.start_date) }}</small>
        <h4>{{ formatDay(user_event.event.start_date) }}</h4>
      </div>
      <div>
        <div class="fw-500">{{user_event.event.event_name}}</div>
        <div class="text-muted text-xs">{{user_event.event.start_time}} -{{user_event.event.end_time}}</div>
      </div>
    </div>
  
    <hr>
  </div>
  <div v-if="user_events.length > visibleCount" class=" mt-2">
    <button class="btn btn-sm btn-transparent text-secondary" @click="toggleShowMore">
    
      <i v-if="showAll" class="bx bxs-up-arrow-circle ms-2"></i> 
      <i v-if="!showAll" class="bx bxs-down-arrow-circle ms-2"></i>

      {{ showAll ? 'See Less' : 'See More' }}
    </button>
  </div>
</div>



